(function() { module.exports = this["wp"]["blockEditor"]; }());